import React, { useState, useEffect } from 'react';
import '../assets/styles/CadastroProdutor.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function CadastroUsuario() {
  const [usuario, setUsuario] = useState({
    nome: '',
    email: '',
    senha: '',
    confirmarSenha: '',
    perfil: 'secretaria',
    ativo: 's',
  });
  const [usuarios, setUsuarios] = useState([]);
  const [editId, setEditId] = useState(null);
  const [mensagem, setMensagem] = useState(null);
  const [forcaSenha, setForcaSenha] = useState({ nivel: '', pontuacao: 0, criterios: [] });
  const [senhasConferem, setSenhasConferem] = useState(true);

  // Buscar usuários da API ao carregar
  useEffect(() => {
    fetch(`${API_BASE_URL}/usuarios/`)
      .then(res => res.json())
      .then(data => {
        // Garantir que perfil nunca seja nulo/vazio
        const usuariosComPerfilMapeado = Array.isArray(data.productId) 
          ? data.productId.map(user => {
              let perfil = user.perfil;
              if (!perfil || perfil.trim() === '') perfil = 'secretaria';
              return { ...user, perfil };
            })
          : [];
        setUsuarios(usuariosComPerfilMapeado);
      })
      .catch(error => {
        console.error('Erro ao buscar usuários:', error);
        setMensagem('Erro ao buscar usuários.');
      });
  }, []);

  // Função para editar usuário
  const handleEdit = (id) => {
    if (editId === id) {
      // Se já estiver no modo de edição, limpa os inputs e volta ao modo de cadastro
      setUsuario({ nome: '', email: '', senha: '', confirmarSenha: '', perfil: 'secretaria', ativo: 's' });
      setEditId(null);
      setMensagem(null);
    } else {
      const u = usuarios.find(u => u.id === id);
      // Garante que o perfil nunca fique vazio ao editar
      setUsuario({ ...u, perfil: u.perfil || 'secretaria' });
      setEditId(id);
      setMensagem(null);
    }
  };

  // Função para deletar usuário via API
  const handleDelete = async (id) => {
    try {
      const res = await fetch(`${API_BASE_URL}/usuarios/delete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id })
      });
      if (res.ok) {
        setUsuarios(usuarios.filter(u => u.id !== id));
        setMensagem('Usuário removido!');
        if (editId === id) {
          setEditId(null);
        }
      } else {
        setMensagem('Erro ao remover usuário.');
      }
    } catch {
      setMensagem('Erro ao remover usuário.');
    }
  };

  // Verifica a força da senha
  const verificarForcaSenha = (senha) => {
    let pontuacao = 0;
    
    // Lista de todos os critérios com status de completude
    const criterios = [
      {
        completo: senha.length >= 8,
        texto: 'Mínimo de 8 caracteres (obrigatório)'
      },
      {
        completo: /[a-z]/.test(senha),
        texto: 'Adicione letras minúsculas'
      },
      {
        completo: /[A-Z]/.test(senha),
        texto: 'Adicione letras maiúsculas'
      },
      {
        completo: /[0-9]/.test(senha),
        texto: 'Adicione números'
      },
      {
        completo: /[^A-Za-z0-9]/.test(senha),
        texto: 'Adicione símbolos especiais (!@#$%&*)'
      }
    ];
    
    // Conta quantos critérios foram atendidos
    pontuacao = criterios.filter(criterio => criterio.completo).length;
    
    // Determina o nível da senha
    let nivel = '';
    if (pontuacao <= 2) {
      nivel = 'fraca';
    } else if (pontuacao <= 3) {
      nivel = 'media';
    } else {
      nivel = 'forte';
    }
    
    return { nivel, pontuacao, criterios };
  };

  // Atualiza o estado conforme o usuário digita
  const handleChange = e => {
    const { name, value } = e.target;
    // Se o campo for perfil e o valor vier vazio, forçar 'secretaria'
    if (name === 'perfil') {
      setUsuario({ ...usuario, perfil: value || 'secretaria' });
    } else {
      setUsuario({ ...usuario, [name]: value });
    }
    
    // Verifica força da senha quando ela é alterada
    if (name === 'senha') {
      const forca = verificarForcaSenha(value);
      setForcaSenha(forca);
      // Verifica se as senhas conferem ao alterar a senha principal
      setSenhasConferem(value === usuario.confirmarSenha || usuario.confirmarSenha === '');
    }
    
    // Verifica se as senhas conferem ao alterar a confirmação
    if (name === 'confirmarSenha') {
      setSenhasConferem(value === usuario.senha || value === '');
    }
  };

  // Ao enviar o formulário
  const handleSubmit = async e => {
    e.preventDefault();
    // Verifica se a senha tem pelo menos 8 caracteres (obrigatório)
    if (usuario.senha.length < 8) {
      setMensagem('A senha deve ter pelo menos 8 caracteres. Este é um requisito obrigatório.');
      return;
    }
    // Verifica se a senha é forte o suficiente
    if (forcaSenha.nivel === 'fraca') {
      setMensagem('Senha muito fraca! Por favor, crie uma senha mais forte antes de continuar.');
      return;
    }
    // Verifica se as senhas conferem
    if (usuario.senha !== usuario.confirmarSenha) {
      setMensagem('As senhas não conferem! Por favor, verifique os campos de senha.');
      return;
    }
    // Garante que o perfil nunca seja vazio ou inválido
    let perfilValido = usuario.perfil;
    if (!perfilValido || perfilValido.trim() === '') {
      perfilValido = 'secretaria';
    }


    if (editId) {
      // Atualizar usuário existente
      try {
        // Recupera a data_cadastro original
        const usuarioAntigo = usuarios.find(u => u.id === editId);
        const dataCadastroOriginal = usuarioAntigo && usuarioAntigo.data_cadastro ? usuarioAntigo.data_cadastro : undefined;
        const res = await fetch(`${API_BASE_URL}/usuarios/update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: editId,
            nome: usuario.nome,
            email: usuario.email,
            senha_hash: usuario.senha,
            perfil: perfilValido,
            ativo: usuario.ativo,
            data_cadastro: dataCadastroOriginal
          })
        });
        if (res.ok) {
          const updatedUser = await res.json();
          // Preserva a data_cadastro original
          const usuarioAntigo = usuarios.find(u => u.id === editId);
          const usuarioAtualizado = {
            ...updatedUser,
            data_cadastro: usuarioAntigo && usuarioAntigo.data_cadastro ? usuarioAntigo.data_cadastro : updatedUser.data_cadastro
          };
          setUsuarios(usuarios.map(u => (u.id === editId ? usuarioAtualizado : u)));
          setMensagem('Usuário atualizado com sucesso!');
          setEditId(null);
          setUsuario({ nome: '', email: '', senha: '', confirmarSenha: '', perfil: 'secretaria', ativo: 's' });
        } else {
          setMensagem('Erro ao atualizar usuário.');
        }
      } catch (error) {
        setMensagem('Erro ao atualizar usuário.');
      }
    } else {
      // Criar novo usuário
      const dadosParaEnvio = {
        nome: usuario.nome,
        email: usuario.email,
        senha_hash: usuario.senha,
        perfil: perfilValido,
        data_cadastro: new Date().toISOString(),
        ativo: usuario.ativo
      };
      try {
        const res = await fetch(`${API_BASE_URL}/usuarios/add`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(dadosParaEnvio)
        });
        if (res.ok) {
          const result = await res.json();
          // Buscar o usuário recém cadastrado pelo id retornado
          if (result && result.productId) {
            const resUser = await fetch(`${API_BASE_URL}/usuarios/${result.productId}`);
            const userData = await resUser.json();
            if (userData && Array.isArray(userData.usuarios) && userData.usuarios.length > 0) {
              setUsuarios([...usuarios, userData.usuarios[0]]);
            }
          }
          setMensagem('Usuário cadastrado com sucesso!');
          setUsuario({ nome: '', email: '', senha: '', confirmarSenha: '', perfil: 'secretaria', ativo: 's' });
          setForcaSenha({ nivel: '', pontuacao: 0, criterios: [] });
          setSenhasConferem(true);
          // Recarregar a lista de usuários para garantir dados atualizados
          setTimeout(() => {
            fetch(`${API_BASE_URL}/usuarios/`)
              .then(res => res.json())
              .then(data => {
                const usuariosComPerfilMapeado = Array.isArray(data.productId) 
                  ? data.productId.map(user => ({
                      ...user,
                      perfil: !user.perfil || user.perfil.trim() === '' ? 'secretaria' : user.perfil
                    }))
                  : [];
                setUsuarios(usuariosComPerfilMapeado);
              })
              .catch(error => console.error('Erro ao recarregar usuários:', error));
          }, 500);
        } else {
          const errorText = await res.text();
          console.log('Erro do backend:', errorText, 'Status:', res.status);
          // Se o erro for relacionado a perfil duplicado, dar uma mensagem mais clara
          if (errorText.includes('perfil') || errorText.includes('administrador') || errorText.includes('mesmo')) {
            setMensagem('Erro: Múltiplos usuários com o mesmo perfil são permitidos. Se você está vendo este erro, pode ser uma restrição do backend que precisa ser removida.');
          } else {
            setMensagem(`Erro ao cadastrar usuário. Status: ${res.status} - ${errorText}`);
          }
        }
      } catch (error) {
        console.error('Erro na requisição:', error);
        setMensagem('Erro ao cadastrar usuário.');
      }
    }
  };

  return (
    <div className="cadastro-produtor-container">
      <h2>Cadastro de Usuário</h2>
      <div className="cadastro-form">
        <form onSubmit={handleSubmit} style={{marginBottom: 32}}>
          <fieldset>
            <legend>Dados do Usuário</legend>
            <label htmlFor="nome">Nome</label>
            <input id="nome" name="nome" value={usuario.nome} onChange={handleChange} required />

            <label htmlFor="email">Email</label>
            <input id="email" name="email" type="email" value={usuario.email} onChange={handleChange} required />

            <label htmlFor="senha">Senha</label>
            <input
              id="senha"
              name="senha"
              type="password"
              value={usuario.senha}
              onChange={handleChange}
              required
            />
            {/* Indicador de força da senha */}
            {usuario.senha && (
              <div className="senha-strength">
                <div className="strength-bar">
                  <div 
                    className={`strength-fill ${forcaSenha.nivel}`}
                    style={{ width: `${(forcaSenha.pontuacao / 5) * 100}%` }}
                  ></div>
                </div>
                <div className={`strength-text ${forcaSenha.nivel}`}>
                  {forcaSenha.nivel === 'fraca' && 'Senha Fraca'}
                  {forcaSenha.nivel === 'media' && 'Senha Média'}
                  {forcaSenha.nivel === 'forte' && 'Senha Forte'}
                </div>
                <div className="strength-suggestions">
                  <small>Critérios de Segurança:</small>
                  <ul>
                    {forcaSenha.criterios.map((criterio, index) => (
                      <li key={index} className={criterio.completo ? 'criterio-completo' : 'criterio-pendente'}>
                        {criterio.texto}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            <label htmlFor="confirmarSenha">Confirmar Senha</label>
            <input
              id="confirmarSenha"
              name="confirmarSenha"
              type="password"
              value={usuario.confirmarSenha}
              onChange={handleChange}
              required
            />
            {/* Indicador de verificação de senha */}
            {usuario.confirmarSenha && (
              <div className="senha-verification">
                {senhasConferem ? (
                  <div className="verification-success">
                    Senhas conferem
                  </div>
                ) : (
                  <div className="verification-error">
                    As senhas não conferem
                  </div>
                )}
              </div>
            )}

            <label htmlFor="perfil">Perfil</label>
            <select id="perfil" name="perfil" value={usuario.perfil || 'secretaria'} onChange={handleChange} required>
              <option value="secretaria">Secretaria</option>
              <option value="tecnico">Técnico</option>
              <option value="administrador">Administrador</option>
            </select>

            <label htmlFor="ativo">Ativo</label>
            <select id="ativo" name="ativo" value={usuario.ativo} onChange={handleChange} required>
              <option value="s">Sim</option>
              <option value="n">Não</option>
            </select>
          </fieldset>
          <button type="submit" className="btn-cadastrar">{editId ? 'Atualizar' : 'Cadastrar'}</button>
          {mensagem && <p className="mensagem-sucesso">{mensagem}</p>}
        </form>

        {/* Tabela de usuários cadastrados */}
        <div style={{width: '100%', background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px #0001', border: '1px solid #e0e0e0', padding: 24, marginBottom: 32}}>
          <h3>Últimos 5 Usuários Cadastrados</h3>
          <p style={{margin: '0 0 12px 0', color: '#555', fontSize: 14}}>
            A tabela abaixo mostra apenas os 5 usuários mais recentemente cadastrados no sistema, considerando o maior ID como o mais novo.
          </p>
          <div style={{width: '100%', overflowX: 'auto'}}>
            <table style={{width: '100%', maxWidth: '100%', borderCollapse: 'collapse', tableLayout: 'fixed'}}>
              <thead>
                <tr style={{ background: '#f7fafc' }}>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Nome</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Perfil</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Ativo</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {usuarios
                  .slice() // cópia para não alterar o original
                  .sort((a, b) => b.id - a.id) // maiores ids primeiro (mais recentes)
                  .slice(0, 5)
                  .map(u => (
                    <tr key={u.id} style={{ background: '#fff' }}>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{u.nome}</td>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>
                        {u.perfil === 'administrador' ? 'Administrador' : u.perfil === 'tecnico' ? 'Técnico' : u.perfil === 'secretaria' ? 'Secretaria' : u.perfil}
                      </td>
                      <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{u.ativo === 's' ? 'Sim' : 'Não'}</td>
                      <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0' }}>
                        <button onClick={() => handleEdit(u.id)} className="btn-acao" style={{marginRight: 8}}>Editar</button>
                        <button onClick={() => handleDelete(u.id)} className="btn-acao excluir">Excluir</button>
                      </td>
                    </tr>
                  ))}
                {usuarios.length === 0 && (
                  <tr key="no-users"><td colSpan={4} style={{textAlign: 'center', color: '#888'}}>Nenhum usuário cadastrado.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="info-section">
          <h3>Informações sobre o Cadastro</h3>
          <div className="info-card">
            <h4>Tipos de Perfil</h4>
            <ul>
              <li><strong>Administrador:</strong> Acesso completo ao sistema, pode criar usuários e editar tudo</li>
              <li><strong>Técnico:</strong> Registra visitas e consulta dados do sistema</li>
              <li><strong>Secretaria:</strong> Acesso somente leitura dos dados e gráficos</li>
            </ul>
            <p><small><strong>Nota:</strong> É possível ter múltiplos usuários com o mesmo perfil. Não há restrição de perfil único.</small></p>
          </div>
          <div className="info-card">
            <h4>Segurança</h4>
            <p>Todas as senhas são criptografadas e armazenadas com segurança. Recomendamos senhas com pelo menos 8 caracteres.</p>
          </div>
          <div className="info-card">
            <h4>Email</h4>
            <p>O email será usado para login no sistema e recuperação de senha. Certifique-se de usar um email válido.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
